import React from 'react';
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {TitleContainerBox} from "./boxes/title-container.box";
import {TitleBox} from "./boxes/title.box";
import {PreviewBox} from "./boxes/preview.box";
import {
    IArenaGameFiltersCategoryEditorViewModel
} from "../../../../services/games-filter/arena-filters/categories/arena-game-filters-category-editor-view-model.interface";
import {observer} from "mobx-react";

interface FilterCategoryHeaderComponentProps {
    category: IArenaGameFiltersCategoryEditorViewModel;
    isOpen: boolean;
    onCategoryToggle: (category: IArenaGameFiltersCategoryEditorViewModel) => void;
}


export const FilterCategoryHeaderComponent = observer(
    class FilterCategoryHeaderComponent extends OrbitComponent<FilterCategoryHeaderComponentProps> {
        private _onClickHandler = () => {
            this.props.onCategoryToggle(this.props.category);
        }


        render() {
            const activeFiltersTexts = this.props.category.getVisibleAppliedFilters().map(f => f.text);
            return (
                <TitleContainerBox onClick={this._onClickHandler} >
                    <TitleBox isOpen={this.props.isOpen}>
                        {this.props.category.title}
                    </TitleBox>

                    <PreviewBox isVisible={!this.props.isOpen && activeFiltersTexts.length > 0}>
                        {activeFiltersTexts.join(', ')}
                    </PreviewBox>
                </TitleContainerBox>
            )
        }
    }
);